
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ModalAttack',
  emits: ['closeModal'],
  props: {
    attack: {
      type: Object,
      required: true,
    },
  },
});
